declare global {
    interface Window {
        webkitAudioContext: AudioContext
        VolumeMeterAudioContext: AudioContext
    }
}


class VolumeMeter
{
    private streamData: Uint8Array<ArrayBuffer>|null = null
    private audioCtx: AudioContext|null = null
    private analyser: AnalyserNode|null = null
    private source: MediaStreamAudioSourceNode | null = null
    private shouldStillPlayAudio: boolean;

    constructor(shouldStillPlayAudio: boolean = false) {
        this.shouldStillPlayAudio = shouldStillPlayAudio
    }

    public setStream(audioOrStream: HTMLAudioElement | MediaStream, ) {
        this.stop()

        this.streamData = new Uint8Array(128)

        window.VolumeMeterAudioContext = window.VolumeMeterAudioContext || new (window.AudioContext || window.webkitAudioContext);

        this.audioCtx = window.VolumeMeterAudioContext;
        this.analyser = this.audioCtx.createAnalyser();
        this.analyser.fftSize = 256;
        this.analyser.smoothingTimeConstant = 0.2;

        if (audioOrStream.constructor.name == 'HTMLAudioElement') {
            // @ts-ignore
            this.source = this.audioCtx.createMediaElementSource(audioOrStream);
        }
        else if (audioOrStream.constructor.name == 'MediaStream') {
            // @ts-ignore
            this.source = this.audioCtx.createMediaStreamSource(audioOrStream);
        }

        if (this.source) {
            this.source.connect(this.analyser);
        }

        if (this.shouldStillPlayAudio) {
            this.analyser.connect(this.audioCtx.destination);
        }
    }

    public getVolume() {
        if (!this.analyser || !this.streamData) {
            return 0
        }
        this.analyser.getByteFrequencyData(this.streamData);
        var total = 0;
        for (var i = 0; i < this.streamData.length; i++)
            total += this.streamData[i];
        return total/1000;
    }

    public stop() {
        if (this.analyser) {
            this.analyser.disconnect()
        }

        if (this.source) {
            this.source.disconnect();
        }
    }
}

export default VolumeMeter